// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2zJlJ","title":"Info_title__3KnbY","links":"Info_links__33y4l","link":"Info_link__2ztNu","logo":"Info_logo__6dD5C"};